import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import ServiceCall from "./serviceCall";
import config from "@/config";
import * as debug from "@/util/debug";

export function getFunctionURL(functionName: string): string {
  return config.functionsBaseURL + functionName;
}

// Initialize Firebase
export function initialize() {
  firebase.initializeApp(config.firebaseConfig);
  firebase.auth().languageCode = "es-ES";
  if (debug.isLocalhost()) {
    firebase.auth().useEmulator("http://localhost:9099");
    firebase.storage().useEmulator("localhost", 9199);
  }
}

export async function postServiceCall<T>(fnName: string, data: unknown): Promise<T> {
  const call = new ServiceCall(getToken());
  return call.Post<T>(getFunctionURL(fnName), data);
}

export async function deleteServiceCall<T>(fnName: string): Promise<T> {
  const call = new ServiceCall(getToken());
  return call.Delete<T>(getFunctionURL(fnName), {});
}

export async function getServiceCall<T>(fnName: string): Promise<T> {
  const call = new ServiceCall(getToken());
  return call.Get<T>(getFunctionURL(fnName), {});
}

export async function downloadCall(fnName: string, post: boolean, data: unknown): Promise<Blob> {
  const call = new ServiceCall(getToken());
  return call.Download(getFunctionURL(fnName), post, data);
}

export function getToken(forceRefresh?: boolean): Promise<string> {
  return new Promise((resolve, reject) => {
    const cu = firebase.auth().currentUser;
    if (cu) {
      cu.getIdToken(forceRefresh)
        .then((token) => resolve(token))
        .catch((err) => reject(err));
    } else {
      resolve("");
    }
  });
}
